export const faqItems = [
  {
    question: "Was ist OOPBuy Spreadsheet?",
    answer:
      "OOPBuy Spreadsheet ist ein kuratiertes Fashion-Shopping-Tool, das die besten Produkte aus China für deutsche Käufer zusammenfasst. Es enthält über 3.000 geprüfte Artikel in Kategorien wie Sneaker, Streetwear, Accessoires und mehr. Alle Produkte werden täglich aktualisiert und von verifizierten Verkäufern bezogen.",
  },
  {
    question: "Ist OOPBuy Spreadsheet sicher?",
    answer:
      "Ja, OOPBuy Spreadsheet arbeitet ausschließlich mit verifizierten Verkäufern und bietet QC-Fotos (Quality Check) für jedes Produkt. Die Zahlungsabwicklung erfolgt über sichere Kanäle und der Versand nach Deutschland ist vollständig tracked.",
  },
  {
    question: "Wie funktioniert der Versand nach Deutschland?",
    answer:
      "Der Versand nach Deutschland erfolgt in der Regel über internationale Speditionen mit Tracking-Nummer. Die Lieferzeit beträgt typischerweise 10–20 Werktage, abhängig von der gewählten Versandmethode. Zollgebühren können anfallen und sollten bei der Kalkulation berücksichtigt werden.",
  },
  {
    question: "Was bedeutet QC bei OOPBuy?",
    answer:
      "QC steht für Quality Control. Bei OOPBuy werden vor dem Versand detaillierte Fotos deiner bestellten Produkte gemacht, damit du die Qualität und Genauigkeit überprüfen kannst. So vermeidest du unangenehme Überraschungen bei der Lieferung.",
  },
  {
    question: "Welche Kategorien bietet OOPBuy Spreadsheet?",
    answer:
      "Das Spreadsheet deckt 14 Hauptkategorien ab: Schuhe, Hoodies & Pullover, T-Shirts, Jacken, Hosen & Shorts, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und Sonstiges. Jede Kategorie wird täglich mit neuen Funden aktualisiert.",
  },
  {
    question: "Wie oft wird das OOPBuy Spreadsheet aktualisiert?",
    answer:
      "Das OOPBuy Spreadsheet wird täglich aktualisiert. Unser Team durchsucht kontinuierlich die besten Quellen nach neuen Produkten, Deals und qualitativ hochwertigen Funden. So bleibt der Inhalt immer frisch und aktuell.",
  },
  {
    question: "Kann ich OOPBuy aus Deutschland nutzen?",
    answer:
      "Absolut! OOPBuy ist speziell für internationale Käufer, auch aus Deutschland, optimiert. Die Website unterstützt deutsche Adressen, und der Versand nach Deutschland ist einer der beliebtesten Routen. Viele deutsche Kunden shoppen bereits erfolgreich über OOPBuy.",
  },
  {
    question: "Was ist der Unterschied zwischen OOPBuy und anderen Agents?",
    answer:
      "OOPBuy zeichnet sich durch seine spezialisierte Spreadsheet-Methode aus, die das Finden bestimmter Produkte erheblich erleichtert. Während andere Agents eine allgemeine Suche bieten, ist OOPBuy fokussiert auf kuratierte Fashion-Funde mit direkten Links und Preisen.",
  },
];